import { CSS } from "../../constants/css";
import { isVisible } from "../../utils/dom";

const instance = ($el: HTMLElement) => {
  const dom = {
    $menu: $el.querySelectorAll<HTMLElement>(".js-menu"),
    $toggleBtn: $el.querySelector<HTMLElement>(".js-menu-toggle"),
    $menuItems: $el.querySelectorAll<HTMLElement>(".js-menu-item"),
    $menuLeafNodes: $el.querySelectorAll<HTMLElement>(".js-menu-leaf-node"),
  };

  const setTabability = () => {
    const burgerVisible = isVisible(dom.$toggleBtn);
    const burgerExpanded = dom.$toggleBtn?.getAttribute("aria-expanded") === "true";

    dom.$menuItems.forEach(($menuItem) => {
      if ((burgerVisible && burgerExpanded) || !burgerVisible) {
        $menuItem.removeAttribute("tabindex");
        return;
      }

      $menuItem.setAttribute("tabindex", "-1");
    });
  };

  const toggle = () => {
    dom.$menu.forEach(($menu) => {
      $menu.classList.toggle(CSS.active);
    });

    dom.$toggleBtn?.classList.toggle(CSS.active);

    dom.$toggleBtn?.setAttribute(
      "aria-expanded",
      dom.$toggleBtn?.getAttribute("aria-expanded") === "true"
        ? "false"
        : "true",
    );

    setTabability();
  };

  const untoggle = () => {
    dom.$menu.forEach(($menu) => {
      $menu.classList.remove(CSS.active);
    });

    dom.$toggleBtn?.classList.remove(CSS.active);

    dom.$toggleBtn?.setAttribute("aria-expanded", "false");

    setTabability();
  };

  dom.$toggleBtn?.addEventListener("click", toggle);

  dom.$menuLeafNodes?.forEach(($element) => {
    $element.addEventListener("click", untoggle);
  });

  screen.orientation.addEventListener("change", setTabability);

  window.addEventListener("resize", setTabability);

  setTabability();
};

export default () => {
  const $nav = document.querySelectorAll<HTMLElement>(".js-nav");

  $nav.forEach(($element) => {
    instance($element);
  });
};
